const initialState = {
  selectedDomain: [],
  ratings: null,
  answerUuidList: [],
  docIdList: [],
  modalState: false,
  modalName: "",
  isConfetti: false,
  defaultSourceFilter: { value: "all", label: "All" },
  notifications:[],
  inlineImagesList: [],
  inlineImagesData: null,
  isRatingLoad:false
};
const domainReducer = (state = initialState, action) => {
  switch (action.type) {
    case "selectDomain":
      state = { ...state, selectedDomain: action.payload };
      return state;
    case "updateSearchDataWithRating":
      let newRating
      if(state.ratings !== null){
        newRating = {...state.ratings, ...action.payload};
      }else{
        newRating = action.payload;
      }
      state = { ...state, ratings: newRating };
      state = { ...state, isRatingLoad: true };
      return state;
    case "updateAnswerUuidList":
      state = { ...state, isRatingLoad: false };
      state = { ...state, answerUuidList: state.answerUuidList.concat(action.payload.answerid) };
      state = { ...state, docIdList: state.docIdList.concat(action.payload.docid) };
      return state;
    case "toggleAFModal":
      state = { ...state, modalState: action.payload.bool };
      state = { ...state, modalName: action.payload.value };
      return state;
    case "toggleConfetti":
      state = { ...state, isConfetti: action.payload };
      return state;
    case "datasourcefilter":
      state = { ...state, defaultSourceFilter: action.payload };
      return state;
    case "allnotifications":
      state = { ...state, notifications: action.payload };
      return state;
    case "newWebsocketMessage":
      let newArr = [];
      newArr.push(action.payload);
      let allNotifications = newArr.concat(state.notifications);
      state = { ...state, notifications: allNotifications };
      return state;
    case "inlineimagesData":
      let newList = state.inlineImagesList.concat(action.payload.list);
      let newObj;
      if(state.inlineImagesData === null){
        newObj = action.payload.data;
      }else{
        let data1 = action.payload.data;
        newObj = {...state.inlineImagesData, data1}
      }
      state = { ...state, inlineImagesList: newList };
      state = { ...state, inlineImagesData: newObj };
      return state;
    default:
      return state;
  }
};

export default domainReducer;
